import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "files" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "relative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Badge = _resolveComponent("Badge")
  const _component_Loader = _resolveComponent("Loader")
  const _component_FilesUpload = _resolveComponent("FilesUpload")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createTextVNode(" Shared Files ")),
          ($data.shared_files.total)
            ? (_openBlock(), _createBlock(_component_Badge, {
                key: 0,
                gray: "",
                style: {"width":"max-content"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($data.shared_files.total), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.show_refreshing)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              inline: "",
              small: ""
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        ($options.show_loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : ($options.show_empty)
            ? (_openBlock(), _createBlock($setup["SharedFilesEmpty"], {
                key: 1,
                onUpload: $options.onUpload
              }, null, 8 /* PROPS */, ["onUpload"]))
            : (_openBlock(), _createBlock($setup["SharedFilesTable"], {
                key: 2,
                ref: "table",
                files: $data.shared_files.files,
                loading: $options.loading,
                count: $data.shared_files.count,
                "all-statuses": $setup.STATUSES,
                "all-exts": $setup.EXTS,
                skip: $data.load_params.skip,
                highlight: $data.highlight,
                onUpdate: $options.loadItems,
                onUpload: $options.onUpload
              }, null, 8 /* PROPS */, ["files", "loading", "count", "all-exts", "skip", "highlight", "onUpdate", "onUpload"]))
      ]),
      _withDirectives(_createVNode(_component_FilesUpload, {
        expanded: "",
        uploads: $data.shared_files.uploads,
        class: "files-upload",
        onDelete: _cache[0] || (_cache[0] = $event => ($data.shared_files.deleteUpload($event)))
      }, null, 8 /* PROPS */, ["uploads"]), [
        [_vShow, $data.shared_files.uploads.length > 0]
      ])
    ])
  ]))
}